const roundTwoDecimals = n => Math.round(n * 100) / 100;
const SIXTEEN_NINE = roundTwoDecimals(16 / 9);
const heightFromWidth = (width, proportion = SIXTEEN_NINE) => {
  const size = width / proportion;
  return roundTwoDecimals(size);
};

export { heightFromWidth, roundTwoDecimals, SIXTEEN_NINE };
